module.exports=[
  {
    "Name": "Green River College",
    "privateORhigherEd": "Higher Education",
    "GradeLevel": "--",
    "District": "Auburn",
    "NumberofClosedDays": 10,
    "ClosureDates": "3/9 (closed), 3/10–3/20 (classes held online)",
    "Source": "OPSI",
    "startDate": "3/9",
    "endDate": "3/20",
    "online": "classes held online from 3/10 to 3/20",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "GreenRiverCollege"
  },
  {
    "Name": "University of Washington (all 3 campuses)",
    "privateORhigherEd": "Higher Education",
    "GradeLevel": "--",
    "District": "Seattle, Bothell, & Tacoma",
    "NumberofClosedDays": 9,
    "ClosureDates": "3/9–3/20 (classes held online)",
    "Source": "OPSI",
    "startDate": "3/9",
    "endDate": "3/20",
    "online": "Campuses remains open, but classes held online",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "UniversityofWashington(all3campuses)"
  },
  {
    "Name": "Renton Technical College",
    "privateORhigherEd": "Higher Education",
    "GradeLevel": "--",
    "District": "Renton",
    "NumberofClosedDays": 2,
    "ClosureDates": "3/9–3/10",
    "Source": "OPSI",
    "startDate": "3/9",
    "endDate": "3/10",
    "online": "",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "RentonTechnicalCollege"
  },
  {
    "Name": "Cascadia College",
    "privateORhigherEd": "Higher Education",
    "GradeLevel": "--",
    "District": "Bothell",
    "NumberofClosedDays": 10,
    "ClosureDates": "3/9–3/20 (classes held online)",
    "Source": "OPSI",
    "startDate": "3/9",
    "endDate": "3/20",
    "online": "Campus remains open, but classes held online",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "CascadiaCollege"
  },
  {
    "Name": "DigiPen Institute of Technology",
    "privateORhigherEd": "",
    "GradeLevel": "",
    "District": "",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "",
    "startDate": "3/9",
    "endDate": "3/22",
    "online": "Campus remains open, but classes held online",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "DigiPenInstituteofTechnology"
  },
  {
    "Name": "Seattle Central College",
    "privateORhigherEd": "",
    "GradeLevel": "",
    "District": "",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "",
    "startDate": "3/9",
    "endDate": "3/27",
    "online": "Campus only open to authorized employees and contractors starting 3/13 at 5 p.m. Classes held online",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "SeattleCentralCollege"
  },
  {
    "Name": "Seattle Pacific University",
    "privateORhigherEd": "",
    "GradeLevel": "",
    "District": "",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "",
    "startDate": "3/9",
    "endDate": "3/30",
    "online": "Campus remains open, but classes held online",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "SeattlePacificUniversity"
  },
  {
    "Name": "Bellevue College",
    "privateORhigherEd": "Higher Education",
    "GradeLevel": "--",
    "District": "Bellevue",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "Bellevue Colllege website/Hearken",
    "startDate": "3/9",
    "endDate": "3/20",
    "online": "Campus remains open, but classes held online",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "BellevueCollege"
  },
  {
    "Name": "Seattle University",
    "privateORhigherEd": "Higher Education",
    "GradeLevel": "--",
    "District": "",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "",
    "startDate": "3/9",
    "endDate": "3/20",
    "online": "Campus remains open, but classes held online",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "SeattleUniversity"
  },
  {
    "Name": "Shoreline Community College",
    "privateORhigherEd": "Higher Education",
    "GradeLevel": "",
    "District": "",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "website, Hearken",
    "startDate": "3/10",
    "endDate": "3/25",
    "online": "Campus remains open, but classes held online; all large events cancelled",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "ShorelineCommunityCollege"
  },
  {
    "Name": "North Seattle College",
    "privateORhigherEd": "Higher Education",
    "GradeLevel": "",
    "District": "",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "website, Hearken",
    "startDate": "3/10",
    "endDate": "3/27",
    "online": "Campus open until 3/16, online classes began 3/10",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "NorthSeattleCollege"
  },
  {
    "Name": "South Seattle College",
    "privateORhigherEd": "Higher Education",
    "GradeLevel": "",
    "District": "",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "email; website",
    "startDate": "",
    "endDate": "3/27",
    "online": "Campus closed, online classes ",
    "SchoolorDistrict": "School",
    "county": "King",
    "id": "SouthSeattleCollege"
  },
  {
    "Name": "Western Washington University",
    "privateORhigherEd": "Higher Education",
    "GradeLevel": "",
    "District": "Bellingham",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "website. ",
    "startDate": "3/11",
    "endDate": "3/20",
    "online": "Campus open, classes ended --  finals to be determied by faculty",
    "SchoolorDistrict": "School",
    "county": "Whatcom",
    "id": "WesternWashingtonUniversity"
  },
  {
    "Name": "Washington State University (all 5 campuses)",
    "privateORhigherEd": "",
    "GradeLevel": "",
    "District": "",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "",
    "startDate": "3/11",
    "endDate": "further notice",
    "online": "Campuses remain open. Online classes begin 3/23, following WSU’s spring break",
    "SchoolorDistrict": "School",
    "county": "Whitman",
    "id": "WashingtonStateUniversity(all5campuses)"
  },
  {
    "Name": "Pacific Lutheran University",
    "privateORhigherEd": "",
    "GradeLevel": "",
    "District": "",
    "NumberofClosedDays": "",
    "ClosureDates": "",
    "Source": "Hearken; website",
    "startDate": "3/10",
    "endDate": "3/30",
    "online": "Campus remains open, but classes will be online",
    "SchoolorDistrict": "School",
    "county": "Pierce",
    "id": "PacificLutheranUniversity"
  }
]